<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main v-if="offer != null" class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('pageGuestOffer.title.offer') }} #{{ offer.offerNumber }}
    </portal>
    <spinner-overlay v-if="creatingPDF" />
    <card :title="$t('pageGuestOffer.card.general')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner v-if="!isNil(inquiry)" :title="$t('pageGuestOffer.card.inquiry')">
        <hm-col :grid="true" cols="12">
          <hm-input-date v-model="inquiry.arrivalDate"
                         :disabled="true"
                         :label="$t('pageGuestOffer.arrivalDate')"
                         cols="12 6@tablet"
                         name="arrivalDate" />
          <hm-input-date v-model="inquiry.departureDate"
                         :disabled="true"
                         :label="$t('pageGuestOffer.departureDate')"
                         cols="12 6@tablet"
                         name="departureDate" />
          <hm-input :value="inquiry.createdAt | toLocalDateTime"
                    :disabled="true"
                    :label="$t('pageGuestOffer.inquiryCreatedAt')"
                    cols="12"
                    name="inquiryCreatedAt" />
          <hm-button class="btn--green" cols="12" icon-left="eye" @click="$router.push({ name: 'inquiry', params: { inquiryId: inquiry.id } })">{{ $t('pageGuestOffer.actionOpenInquiry') }}</hm-button>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <label-value-dotted :value="roomCount" :label="$t('pageGuestOffer.general.roomCount')" />
        <label-value-dotted :value="amount | toCurrency" :unit="hotelSettings.details.currency" :label="$t('pageGuestOffer.general.amount')" class="label-value-dotted__wrapper--sum" />
        <label-value-dotted v-if="hasLicense('AdditionalServices')" :value="shoppingCartAmount | toCurrency" :unit="hotelSettings.details.currency" :label="$t('pageGuestOffer.general.additionalServices')" />
        <label-value-dotted :value="excludedTaxAmount | toCurrency" :unit="hotelSettings.details.currency" :label="$t('pageGuestOffer.general.taxes')" />
        <label-value-dotted :value="(amount + excludedTaxAmount + shoppingCartAmount) | toCurrency" :unit="hotelSettings.details.currency" :label="$t('pageGuestOffer.general.total')" class="label-value-dotted__wrapper--sum label-value-dotted__wrapper--bold" />
      </hm-card-inner>
    </card>

    <card :title="$t('pageGuestOffer.card.remarks')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-textarea v-model="offer.guestComment" :label="$t('pageGuestOffer.guestComment')" name="guestComment" />
      <hm-textarea v-model="offer.internalComment" :label="$t('pageGuestOffer.internalComment')" name="internalComment" />
    </card>

    <template v-for="(roomOffer, offerIdx) in offer.roomOffers">
      <card :title="$t('pageGuestOffer.card.room', {idx: offerIdx+1})"
            :key="roomOffer.id"
            :id="`offer-${offerIdx}`"
            cols="12 8@desktop 9@hd start-1"
            rows="3">
        <hm-card-inner :deletable="offer.roomOffers.length > 1 && isEmpty(roomOffer.reservationId) && isEmpty(roomOffer.reservationIds)" :title="$t('pageGuestOffer.card.offerDetails')" @delete="deleteRoomOffer(roomOffer.id)">
          <hm-input-date v-model="roomOffer.arrivalDate"
                         :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                         :label="$t('pageGuestOffer.arrivalDate')"
                         cols="12 6@tablet 3@desktop"
                         name="arrivalDate" />
          <hm-input-date v-model="roomOffer.departureDate"
                         :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                         :min-date="roomOffer.arrivalDate"
                         :label="$t('pageGuestOffer.departureDate')"
                         cols="12 6@tablet 3@desktop"
                         name="departureDate" />
          <hm-input-select v-model="roomOffer.roomTypeId"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.roomType')"
                           cols="12 6@tablet 3@desktop"
                           name="roomType">
            <option v-for="item in hotelSettings.roomTypes.all(roomOffer.roomTypeId)" :value="item.id">{{ item.name[$shortLocale] }} ({{ $t('pageGuestOffer.roomTypeAvailableRooms', { count: getAvailableCount(roomOffer.id,item.id) }) }})</option>
          </hm-input-select>
          <hm-input-select v-model="roomOffer.ratePlanId"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.rate')"
                           cols="12 6@tablet 3@desktop"
                           name="rate">
            <option v-for="item in hotelSettings.ratePlans.all(roomOffer.ratePlanId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select v-model="roomOffer.roomCount"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.selectedRooms')"
                           name="selectedRooms"
                           cols="12 6@tablet 3@desktop"
                           @input="roomOffer.roomNumber = null">
            <option v-for="index in 99" :value="index" v-html="index"></option>
          </hm-input-select>
          <hm-input-select v-if="roomOffer.roomCount === 1"
                           v-model="roomOffer.roomNumber"
                           :key="unavailableRoomKey"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.roomNumber')"
                           name="roomNumber"
                           cols="12 6@tablet 3@desktop">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.rooms.all(roomOffer.roomNumber)" :value="item.roomNumber" v-html="`${item.roomNumber} (${item.roomType.name[$shortLocale]}) ${!isNil(unavailableRooms[roomOffer.id]) && unavailableRooms[roomOffer.id].includes(item.roomNumber) ? 'BELEGT' : ''}`"></option>
          </hm-input-select>
          <hm-input-select v-model="roomOffer.numAdults"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.numAdults')"
                           name="numAdults"
                           cols="12 6@tablet 3@desktop">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - roomOffer.numChildren)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-if="hasLicense('ChildRates')"
                           v-model="roomOffer.numChildren"
                           :disabled="!isEmpty(roomOffer.reservationId)|| !isEmpty(roomOffer.reservationIds)"
                           :label="$t('pageGuestOffer.numChildren')"
                           name="numChildren"
                           cols="12 6@tablet 3@desktop"
                           @input="onUpdateNumChildren(roomOffer)"
                           @change="onUpdateNumChildren(roomOffer)">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - roomOffer.numAdults)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-for="child in intArray(roomOffer.numChildren)"
                           v-model="roomOffer.childAgeCategories[child+1]"
                           :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                           :label="$tc('pageGuestOffer.child', child, { count: child+1 })"
                           :key="child"
                           :required="true"
                           name="childAge"
                           cols="12 6@tablet 3@desktop">
            <option v-for="item in hotelSettings.ageCategories.all(roomOffer.childAgeCategories[child+1])" v-if="item.ageQualifier === 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]}`"></option>
            <option v-for="item in hotelSettings.ageCategories.all(roomOffer.childAgeCategories[child+1])" v-if="item.ageQualifier !== 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]} (${item.ageFrom} - ${item.ageUntil})`"></option>
          </hm-input-select>
          <template v-if="!isEmpty(rates) && !isNil(rates[roomOffer.id]) && !isNil(rates[roomOffer.id].policies)">
            <hm-input-select v-model="rates[roomOffer.id].policies.policyOverride"
                             :label="$t('pageRoomReservation.policies.policyOverride')"
                             cols="12 6@desktop start-1"
                             no-select-label
                             @input="debouncedSaveRates(roomOffer.id)">
              <option :value="null">{{ getRatePlanPolicyName(roomOffer.ratePlanId) }}</option>
              <option v-for="itItem in hotelSettings.policies.all(rates[roomOffer.id].policies.policyOverride)"
                      :key="itItem.id"
                      :value="itItem.id">{{ itItem.name }}
              </option>
            </hm-input-select>
          </template>
        </hm-card-inner>
        <hm-card-inner v-if="!isNil(roomOffer.discount)" :title="$t('pageGuestOffer.card.discount')">
          <hm-input-money v-model="roomOffer.discount.percentage"
                          :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                          :label="$t('pageGuestOffer.discount')"
                          :help="$t('pageGuestOffer.discount_help')"
                          name="discount"
                          currency="%"
                          validate="max_value:100|min_value:0"
                          cols="12 6@tablet 3@desktop">
          </hm-input-money>
          <hm-input v-if="hasLicense('DiscountCode')"
                    :lazy="true"
                    v-model="roomOffer.discount.discountCode"
                    :disabled="!isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                    :label="$t('pageGuestOffer.discountCode')"
                    name="discountCode"
                    cols="12 6@tablet 3@desktop">
          </hm-input>
          <!-- disabled because it's read only and might confuse users - in addition it doesn't update on rate change -->
          <!--          <hm-input-money :lazy="true"-->
          <!--                          v-model="roomOffer.prepaymentAmount"-->
          <!--                          :disabled="true"-->
          <!--                          :currency="hotelSettings.details.currency"-->
          <!--                          :label="$t('pageGuestOffer.prepaymentAmount')"-->
          <!--                          :help="$t('pageGuestOffer.prepaymentAmount_help')"-->
          <!--                          name="prepaymentAmount"-->
          <!--                          cols="12 6@tablet 3@desktop">-->
          <!--          </hm-input-money>-->
        </hm-card-inner>
        <!--        <template v-if="!isEmpty(rates) && !isNil(rates[roomOffer.id]) && !isNil(rates[roomOffer.id].policies)">-->
        <!--          <hm-card-inner :title="$t('pageRoomReservation.card.policies')">-->
        <!--            <hm-input-select v-model="rates[roomOffer.id].policies.policyOverride"-->
        <!--                             :label="$t('pageRoomReservation.policies.policyOverride')"-->
        <!--                             cols="12 6@desktop"-->
        <!--                             no-select-label>-->
        <!--              <option :value="null">{{ $t('pageRoomReservation.policies.policyOverrideNoSelectOption') }} ({{ getRatePlanPolicyName(roomOffer.ratePlanId) }})</option>-->
        <!--              <option v-for="itItem in hotelSettings.policies.all(rates[roomOffer.id].policies.policyOverride)"-->
        <!--                      :key="itItem.id"-->
        <!--                      :value="itItem.id">{{ itItem.name }}-->
        <!--              </option>-->
        <!--            </hm-input-select>-->
        <!--            &lt;!&ndash;            <policies :rates="rates[roomOffer.id]" cols="12 6@desktop start-1"/>&ndash;&gt;-->
        <!--          </hm-card-inner>-->
        <!--        </template>-->
        <hm-card-inner :full-size="true">
          <rate-editor v-if="!isEmpty(rates) && !isEmpty(rates[roomOffer.id])"
                       :rates.sync="rates[roomOffer.id]"
                       :num-nights="roomOffer.numNights"
                       :arrival-date="roomOffer.arrivalDate"
                       :departure-date="roomOffer.departureDate"
                       :locked="rateUpdateInProgress || !isEmpty(roomOffer.reservationId) || !isEmpty(roomOffer.reservationIds)"
                       :updating="rateUpdateInProgress"
                       :discount="roomOffer.discount"
                       @ratechange="debouncedSaveRates(roomOffer.id)" />
        </hm-card-inner>
        <template v-if="isEmpty(roomOffer.reservationId) && isEmpty(roomOffer.reservationIds) && getAvailableCount(roomOffer.id, roomOffer.roomTypeId) <= 0">
          <hm-card-inner :full-size="true">
            <hm-col cols="12">
              <span class="warning-text warning-text--full-size warning-text--no-margin col-12"><b>{{ $t('pageGuestOffer.warning') }}:</b> {{ $t('pageGuestOffer.warningRoomTypeFullyBooked') }}</span>
            </hm-col>
          </hm-card-inner>
        </template>
        <hm-card-inner class="rtl">
          <hm-button v-if="hasLicense('AdditionalServices') && isEmpty(roomOffer.reservationId) && isEmpty(roomOffer.reservationIds)"
                     class="btn--blue btn--no-margin"
                     cols="12 6@tablet 3@desktop 2@hd"
                     icon-left="plus"
                     @click="showAddTransactionModal = roomOffer.id">{{ $t('pageGuestOffer.actions.addAdditionalService') }}</hm-button>
          <hm-button v-if="!isEmpty(roomOffer.reservationId)"
                     class="btn--green btn--no-margin"
                     cols="12 6@tablet 3@desktop 2@hd"
                     icon-left="eye"
                     @click="$router.push({ name: 'reservation', params: { reservationId: roomOffer.reservationId } })">{{ $t('pageGuestOffer.actionOpenReservation') }}</hm-button>
          <template v-if="!isEmpty(roomOffer.reservationIds)">
            <hm-button v-for="(reservationId, idx) in roomOffer.reservationIds"
                       :key="reservationId"
                       class="btn--green btn--no-margin"
                       cols="12 6@tablet 3@desktop 2@hd"
                       icon-left="eye"
                       @click="$router.push({ name: 'reservation', params: { reservationId: reservationId } })">{{ $t('pageGuestOffer.actionOpenReservationIdx', {idx: roomOffer.reservationIds.length - idx}) }}</hm-button>
          </template>
          <hm-button v-if="isEmpty(roomOffer.reservationId) && isEmpty(roomOffer.reservationIds)"
                     :disabled="!hasAnyRole(['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION', 'ROLE_ADMIN', 'ROLE_SYSADMIN'])"
                     class="btn--green btn--no-margin"
                     cols="12 6@tablet 3@desktop 2@hd"
                     icon-left="save"
                     @click="createReservation(roomOffer.id)">{{ $t('pageGuestOffer.actionCreateReservation') }}</hm-button>
          <hm-button class="btn--orange btn--no-margin" cols="12 6@tablet 3@desktop 2@hd" icon-left="copy" @click="duplicateRoomOffer(roomOffer.id)">{{ $t('pageGuestOffer.actionDuplicateOffer') }}</hm-button>
        </hm-card-inner>
      </card>
    </template>

    <card :title="$t('pageGuestOffer.card.offer')" cols="12 start-1">
      <hm-card-inner>
        <hm-input-select v-model="offer.templateId"
                         :label="$t('pageGuestOffer.template')"
                         validate="required"
                         name="template"
                         cols="12 6@tablet 4@desktop 3@hd"
                         @input="updateContent">
          <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
          <template slot="icon-inline-right">
            <input-icon-button v-tooltip="{ title: isEmpty(offer.templateId) ? $t('pageGuestOffer.actions.selectTemplateFirst') : $t('pageGuestOffer.actionUpdateText'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                               :class="[{'disabled': isEmpty(offer.templateId)}]"
                               :border="true"
                               icon="refresh"
                               @click="updateContent" />
          </template>
        </hm-input-select>
        <hm-input v-model="offer.contentHeadline" :label="$t('pageGuestOffer.contentHeadline')" name="contentHeadline" cols="12 6@tablet 4@desktop 3@hd start-1" />
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <ckeditor v-model="offer.contentHtml" height="500" />
        </hm-col>
      </hm-card-inner>
    </card>

    <tabable-card id="guests" :active-card="activeGuestCard" cols="12 6@tablet 4@desktop 3@hd start-1 start-7@tablet start-9@desktop start-10@hd" rows="1 2@desktop start-1">
      <tabable-card-content :title="$t('pageGuestOffer.card.guest')" :indicator="isEmpty(offer.guestDetail.guestProfileId) ? null : 'green'">
        <guest-profile-editor id="guest" v-model="offer.guestDetail.guestProfileId" type="Guest" />
      </tabable-card-content>
      <tabable-card-content :title="$t('pageGuestOffer.card.company')" :indicator="isEmpty(offer.companyDetail.guestProfileId) ? null : 'green'">
        <guest-profile-editor id="company" v-model="offer.companyDetail.guestProfileId" type="Company" />
      </tabable-card-content>
      <tabable-card-content :title="$t('pageGuestOffer.card.travelAgent')" :indicator="isEmpty(offer.travelAgentDetail.guestProfileId) ? null : 'green'">
        <guest-profile-editor id="travelagent" v-model="offer.travelAgentDetail.guestProfileId" type="TravelAgent" />
      </tabable-card-content>
    </tabable-card>


    <card :title="$t('pageGuestOffer.card.correspondence')" cols="12" min-height="25rem">
      <hm-card-inner :full-size="true">
        <hm-col v-if="!isNil(correspondence)" cols="12">
          <correspondence-table :correspondence="correspondence" :items-per-page="10" />
        </hm-col>
      </hm-card-inner>
    </card>

    <modal v-if="showAddTransactionModal !== false"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageGuestOffer.card.addAdditionalService')"
           :confirm-label="$t('pageGuestOffer.confirmAddAdditionalService')"
           @confirm="addShoppingCartItem()"
           @cancel="showAddTransactionModal=false">
      <hm-card-inner min-height="35.8rem">
        <hm-col :grid="true" cols="12">
          <hm-input-select v-model="newShoppingCartItem.inHouseServiceId" :label="$t('pageGuestOffer.transactionCode')" name="transactionCode" @input="onChangeShoppingCartItemId">
            <option :value="null" :disabled="true"></option>
            <optgroup v-for="group in additionalServices" :label="group.group">
              <option v-for="item in group.options" v-if="!isNil(item.amount)" :value="item.id" v-html="item.name"></option>
            </optgroup>
          </hm-input-select>
          <hm-input-number v-model="newShoppingCartItem.itemCount" :label="$t('pageGuestOffer.itemCount')" name="itemCount" cols="6" />
          <hm-input-money v-model="newShoppingCartItem.itemPrice"
                          :currency="hotelSettings.details.currency"
                          :label="$t('pageGuestOffer.itemPrice')"
                          name="itemPrice"
                          cols="6" />
          <hm-input v-model="newShoppingCartItem.alternativeLabel" :label="$t('pageGuestOffer.itemAlternativeLabel')" name="alternativeLabel" cols="6" />
          <hm-input-date v-if="newShoppingCartItem.date != null"
                         v-model="newShoppingCartItem.date"
                         :min-date="minCheckInDate"
                         :max-date="maxCheckOutDate"
                         :min-date-inclusive="true"
                         :label="$t('pageGuestOffer.itemDate')"
                         name="itemDate"
                         cols="6" />
        </hm-col>
      </hm-card-inner>
    </modal>

    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :label="$t('pageGuestOffer.actions.more')" icon="fill-more" color="gray">
        <hm-floating-child-button :label="$t('pageGuestOffer.actions.createEmail')" icon="send-email" color="blue" @click="createEmail" />
        <hm-floating-child-button :disabled="isContentEmpty"
                                  :label="$t('pageGuestOffer.actions.createPDF')"
                                  icon="pdf"
                                  color="blue"
                                  @click="createPDF" />
      </hm-floating-button>
      <!-- eslint-disable vue/no-confusing-v-for-v-if -->
      <hm-floating-button v-if="isContentEmpty"
                          :label="$t('pageGuestOffer.actions.selectTemplateFirst')"
                          :disabled="true"
                          icon="send-email"
                          color="blue"
                          @click="createPDFAndSend" />
      <hm-floating-button v-else
                          :label="$t('pageGuestOffer.actions.createPDFandEmail')"
                          icon="send-email"
                          color="blue"
                          @click="createPDFAndSend" />
    </hm-floating-buttons>

  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, debounce, get, groupBy, head, isEmpty, isNil, max, min, pull, sortBy, sum, sumBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmCardInner from '../lib/layout/HmCardInner';
import uuid from 'uuid';
import TimerMixin from '../../mixins/TimerMixin';
import promiseRetry from 'promise-retry';
import HmInputSelect from '../lib/inputs/HmInputSelect.vue';
import Policies from '../lib/util/Policies.vue';
import HmInput from '../lib/inputs/HmInput.vue';

export default {
  name: 'PageGuestOffer',
  components: {
    HmInput,
    Policies,
    HmInputSelect,
    HmCardInner },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'offer',
      variable: 'offer',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.offer.get(this, this.guestOfferId), this.offer)
          .then((response) => {
            this.updateRates();
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      exclude: ['contentHeadline', 'contentHtml', 'guestComment', 'internalComment', 'guestDetail', 'companyDetail', 'travelAgentDetail'],
    },
    {
      name: 'offerTemplate',
      variable: 'offer',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.offer.get(this, this.guestOfferId), this.offer)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      include: ['contentHeadline', 'contentHtml', 'guestComment', 'internalComment', 'guestDetail', 'companyDetail', 'travelAgentDetail'],
    },
  ],

  data() {
    return {
      unavailableRooms: {},
      creatingPDF: false,
      content: '',
      offer: null,
      rates: null,
      correspondence: [],
      inquiry: null,
      templates: [],
      rateUpdateInProgress: false,
      debouncedUpdateRates: null,
      debouncedSaveRates: null,
      unavailableRoomKey: '-',
      showAddTransactionModal: false,
      newShoppingCartItem: {
        id: uuid.v4(),
        inHouseServiceId: null,
        itemCount: 1,
        itemPrice: 0,
        alternativeLabel: null,
        date: null,
      },
      guestOfferId: null,
      roomOfferRoomTypeAvailability: {},
    };
  },

  computed: {
    minCheckInDate: function () {
      if (isNil(this.offer) || isEmpty(this.offer.roomOffers)) return this.$moment().format('YYYYMMDD');
      const offer = this.offer.roomOffers.find(it => this.showAddTransactionModal === it.id);
      if (!isNil(offer)) return offer.arrivalDate;
      return min(this.offer.roomOffers.map(it => it.arrivalDate));
    },
    maxCheckOutDate: function () {
      if (isNil(this.offer) || isEmpty(this.offer.roomOffers)) return this.$moment().format('YYYYMMDD');
      const offer = this.offer.roomOffers.find(it => this.showAddTransactionModal === it.id);
      if (!isNil(offer)) return offer.departureDate;
      return max(this.offer.roomOffers.map(it => it.departureDate));
    },
    isContentEmpty: function () {
      return isEmpty(this.offerText);
    },
    offerText: function () {
      if (isEmpty(this.offer.contentHtml)) return '';
      const tmp = document.createElement('div');
      tmp.innerHTML = this.offer.contentHtml;
      return tmp.innerText.trim();
    },
    activeGuestCard: function () {
      if (isNil(this.offer)) return 0;

      if (!isNil(this.offer.guestDetail.guestProfileId)) {
        return 0;
      } else if (!isNil(this.offer.guestDetail.guestProfileId)) {
        return 1;
      } else if (!isNil(this.offer.guestDetail.guestProfileId)) {
        return 2;
      } else {
        return 0;
      }
    },
    roomCount: function () {
      if (isNil(this.offer)) return 0;

      return sumBy(this.offer.roomOffers, it => it.roomCount);
    },
    amount: function () {
      if (isNil(this.rates)) return 0;

      return sum(Object.entries(this.rates).map(it => it[1].unitPriceSummary.amount * (this.offer.roomOffers.find(roomOffer => roomOffer.id === it[0]).roomCount || 0)));
    },
    excludedTaxAmount: function () {
      if (isNil(this.rates)) return 0;

      return sum(Object.entries(this.rates).map(it => it[1].unitPriceSummary.excludedTaxAmount * (this.offer.roomOffers.find(roomOffer => roomOffer.id === it[0]).roomCount || 0))) + this.shoppingCartExcludedTaxAmount;
    },
    shoppingCartAmount: function () {
      if (isNil(this.rates)) return 0;

      return sum(Object.entries(this.rates).map(it => it[1].shoppingCartSummary.amount * (this.offer.roomOffers.find(roomOffer => roomOffer.id === it[0]).roomCount || 0)));
    },
    shoppingCartExcludedTaxAmount: function () {
      if (isNil(this.rates)) return 0;

      return sum(Object.entries(this.rates).map(it => it[1].shoppingCartSummary.excludedTaxAmount * (this.offer.roomOffers.find(roomOffer => roomOffer.id === it[0]).roomCount || 0)));
    },
    additionalServices: function () {
      return [
        ...sortBy(
          Object.entries(groupBy(this.hotelSettings.inHouseServices.all(), it => it.type))
            .map(it => ({
              group: this.$t(`InHouseServiceType.${it[0]}`),
              options: sortBy(it[1].map((ihs) => {
                const ret = {
                  id: ihs.id,
                  name: ihs.name[this.$shortLocale],
                  type: 'InHouseService',
                  amount: ihs.amount,
                };

                if (ihs.rateFrequency === 'PerNight') {
                  ret.name = `${ret.name} (${this.$t('RateFrequency.PerNight')})`;
                }

                return ret;
              }), ihs => ihs.name),
            })),
          it => it.group,
        ),
      ];
    },
  },

  created: function () {
    this.guestOfferId = this.$route.params.guestOfferId;
    this.debouncedUpdateRates = debounce(this.updateRates, 1000);
    this.debouncedSaveRates = debounce(this.saveRates, 1000);
    this.updateOffer().then(() => {
      this.updateRates();
    });

    this.updateTemplates();
    this.updateCorrespondence();
  },

  mounted: function () {
    // CKEDITOR.plugins.addExternal( 'justify', requestContextPath+'/scripts/ckeditor/plugins/justify/', 'plugin.js' );
  },

  methods: {
    updateRoomTypeAvailability(roomOffer) {
      if (isEmpty(roomOffer)) return;

      const days = this.$moment.duration(this.$moment(roomOffer.departureDate, 'YYYYMMDD').diff(roomOffer.arrivalDate)).asDays();

      this.axios.get(this.serviceUrls.roomTypePlan(this), {
        params: {
          start: roomOffer.arrivalDate,
          limit: Math.abs(Math.round(days)) - 1,
        },
        headers: {
          Accept: 'application/x-protobuf',
        },
        responseType: 'arraybuffer',
      }).then((response) => {
        const byRoomType = response.data.data.ByRoomType;
        const roomTypeAvailability = {};

        if (!isNil(byRoomType)) {
          const keys = Object.keys(byRoomType);
          this.hotelSettings.roomTypes.all()
            .forEach((roomType) => {
              roomTypeAvailability[roomType.id] = head(
                keys.map(date => response.data.data.ByRoomType[date].value[roomType.id])
                  .sort((a, b) => a - b),
              );
            });

          this.$set(this.roomOfferRoomTypeAvailability, roomOffer.id, roomTypeAvailability);
        } else {
          this.$set(this.roomOfferRoomTypeAvailability, roomOffer.id, null);
        }
      });
    },
    updateUnavailableRooms(roomOffer) {
      if (isEmpty(roomOffer)) return;
      this.updateRoomTypeAvailability(roomOffer);
      this.axios.post(this.serviceUrls.availability.unavailableRooms(this), {
        arrivalDate: roomOffer.arrivalDate,
        departureDate: roomOffer.departureDate,
        reservationId: null,
      })
        .then((response) => {
          this.unavailableRooms[roomOffer.id] = response.data.data.unavailableRooms || [];
          this.unavailableRoomKey = uuid.v4();
        });
    },
    deleteRoomOffer(roomOfferId) {
      const offer = this.offer.roomOffers.find(it => roomOfferId === it.id);

      pull(this.offer.roomOffers, offer);
    },
    duplicateRoomOffer(roomOfferId) {
      const offer = this.offer.roomOffers.find(it => roomOfferId === it.id);

      if (isNil(offer)) return;

      const newOffer = cloneDeep(offer);
      newOffer.id = uuid.v4();
      newOffer.reservationId = null;
      newOffer.reservationIds = null;
      newOffer.roomNumber = null;

      this.offer.roomOffers.push(newOffer);
    },
    createReservation(roomOfferId, overbook = false) {
      return this.axios
        .post(this.serviceUrls.offer.createReservation(this, this.guestOfferId, roomOfferId, overbook))
        .then((response) => {
          this.showSuccessMessage();
          this.updateOffer();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showModal(this.$t('pageGuestOffer.confirmCreationFailedTryOverbooking'), () => { this.createReservation(roomOfferId, true); });
        });
    },
    createEmail() {
      /* required to explicitely set attachment and templateType to null - because if
       * 1) the user clicks create PDF & send email
       * 2) then clicks back (all the existing params are returned)
       * 3) then the user clicks ond send email all the existing params would be passed, leading to an inability to select general email templates
       */
      this.$router.push({ name: 'offerEmail', params: { ...this.$route.params, attachment: null, templateType: null } });
    },
    createPDFAndSend() {
      const oldCorrespondenceLength = this.correspondence.length;
      this.createPDF()
        .then(() => {
          if (this.correspondence.length > oldCorrespondenceLength) {
            this.$router.push({ name: 'offerEmail', params: { ...this.$route.params, templateType: 'GuestOfferEmail', attachment: 'LATEST' } });
          } else {
            // sometimes RYOW (read yor own write) doesn't work properly when you hit a different server - so we are adding a slight delay, to make sure that we can read the PDF file we just saved,
            promiseRetry(
              (retry, number) => this.updateCorrespondence()
                .then((_) => {
                  if (this.correspondence.length > oldCorrespondenceLength) {
                    this.$router.push({ name: 'offerEmail', params: { ...this.$route.params, templateType: 'GuestOfferEmail', attachment: 'LATEST' } });
                    return Promise.resolve();
                  } else {
                    throw new Error('Correspondence count unchanged - waiting for PDF');
                  }
                }).catch(retry),
              {
                retries: 5,
                factor: 1.75,
                minTimeout: 500,
                maxTimeout: 7500,
              },
            );
          }
        });
    },
    createPDF() {
      return this.axios
        .post(this.serviceUrls.offer.createPDF(this, this.guestOfferId))
        .then((response) => {
          this.showSuccessMessage();
          return this.updateCorrespondence();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.creatingPDF = false;
        });
    },
    updateOffer() {
      return this.axios
        .get(this.serviceUrls.offer.get(this, this.guestOfferId))
        .then((response) => {
          this.offer = response.data.data;
          this.updateInquiry();
          if (!isNil(this.offer.roomOffers)) {
            this.offer.roomOffers.forEach((it) => {
              this.updateUnavailableRooms(it);
            });
          }
        });
    },
    updateCorrespondence() {
      return this.axios
        .get(this.serviceUrls.offer.correspondence(this, this.guestOfferId))
        .then((response) => {
          this.correspondence = response.data.data;
          return response;
        });
    },
    updateInquiry() {
      if (isNil(this.offer.inquiryId)) {
        this.inquiry = null;
        return Promise.resolve();
      }

      return this.axios
        .get(this.serviceUrls.inquiry.get(this, this.offer.inquiryId))
        .then((response) => {
          this.inquiry = response.data.data;
        });
    },
    updateRates() {
      if (!isNil(this.offer.roomOffers)) {
        this.offer.roomOffers.forEach((it) => {
          this.updateUnavailableRooms(it);
        });
      }

      this.rateUpdateInProgress = true;
      return this.axios
        .get(this.serviceUrls.offer.rates(this, this.guestOfferId))
        .then((response) => {
          this.rates = response.data.data;

          this.offer.roomOffers.map(it => this.rates[it.id]).forEach((itRates) => {
            if (!isNil(itRates)) {
              itRates.rates.forEach((it) => {
                if (isNil(it.customAmount)) it.customAmount = it.amount;
              });
            }
          });
        })
        .finally(() => { this.rateUpdateInProgress = false; });
    },
    saveRates(roomOfferId) {
      if (isNil(this.rates) || isNil(this.rates[roomOfferId])) return;

      this.rateUpdateInProgress = true;
      this.axios
        .put(this.serviceUrls.offer.roomOfferRates(this, this.guestOfferId, roomOfferId), {
          ...this.rates[roomOfferId],
          policyOverride: !isEmpty(this.rates) && !isEmpty(this.rates[roomOfferId]) && !isEmpty(this.rates[roomOfferId].policies) ? this.rates[roomOfferId].policies.policyOverride : null,
        })
        .then((response) => {
          this.updateRates()
            .finally(() => { this.rateUpdateInProgress = false; });
        })
        .catch((error) => {
          this.rateUpdateInProgress = false;
        });
    },
    updateTemplates() {
      this.axios.get(this.serviceUrls.templateHelper.filter(this, 'GuestOfferDocument'))
        .then((response) => {
          this.templates = response.data.data;
        });
    },
    onUpdateNumChildren: function (offer) {
      if (isNil(offer)) return;
      const children = this.intArray(offer.numChildren, 1);
      const defaultAgeCategoryId = isNil(this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult'))
        ? this.hotelSettings.ageCategories.all().find(it => it.ageQualifier === 'Adult').id
        : this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult').id;
      children.forEach((it) => {
        if (isEmpty(get(offer.childAgeCategories, it, null))) {
          if (isNil(offer.childAgeCategories)) offer.childAgeCategories = {};
          offer.childAgeCategories[it] = defaultAgeCategoryId;
        }
      });
    },
    updateContent() {
      if (isNil(this.offer)) return;
      if (isEmpty(this.offer.templateId)) return;

      const renderParams = {
        confirmationCode: null,
        reservationIds: null,
        guestOfferId: this.guestOfferId,
        guestProfileId: this.offer.guestDetail.guestProfileId || this.offer.companyDetail.guestProfileId || this.offer.travelAgentDetail.guestProfileId,
        invoiceNumber: null,
        receiptIdentifier: {
          parentId: null,
          receiptId: null,
        },
        folioIdentifier: {
          parentId: null,
          folioId: null,
        },
      };

      this.axios.post(this.serviceUrls.templateHelper.render(this, this.offer.templateId), renderParams)
        .then((response) => {
          this.offer.contentHtml = response.data.data.content;
          this.offer.contentHeadline = response.data.data.title;
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    onChangeShoppingCartItemId: function () {
      const obj = isEmpty(this.newShoppingCartItem.inHouseServiceId) ? null : this.findHotelSettingById('inHouseServices', this.newShoppingCartItem.inHouseServiceId);
      if (isEmpty(obj)) {
        this.newShoppingCartItem.itemPrice = 0.0;
        this.newShoppingCartItem.itemCount = 1.0;
        this.newShoppingCartItem.inHouseService = null;
        this.newShoppingCartItem.alternativeLabel = null;
        this.newShoppingCartItem.date = null;
      } else {
        this.newShoppingCartItem.itemPrice = obj.amount;
        this.newShoppingCartItem.itemCount = 1.0;
        this.newShoppingCartItem.inHouseService = obj;
        this.newShoppingCartItem.alternativeLabel = null;
        this.newShoppingCartItem.date = obj.rateMode === 'PerRoom' && obj.rateFrequency === 'PerStay' ? (this.newShoppingCartItem.date || this.maxCheckOutDate) : null;
      }
    },
    addShoppingCartItem: function () {
      const offer = this.offer.roomOffers.find(it => this.showAddTransactionModal === it.id);
      const rates = this.rates[offer.id];

      if (isNil(this.newShoppingCartItem.inHouseServiceId)) {
        return;
      }
      if (isNil(this.newShoppingCartItem.itemCount === 0)) {
        return;
      }
      if (!isNil(rates)) {
        if (isNil(rates.shoppingCart)) {
          rates.shoppingCart = [this.newShoppingCartItem];
        } else {
          if (rates.shoppingCart.filter(it => it.inHouseServiceId === this.newShoppingCartItem.inHouseServiceId).length > 0) {
            // this.showWarningMessage('Diese Zusatzleistung wurde zuvor bereits mind. 1 mal hinzugefügt.');
          }
          rates.shoppingCart.push(this.newShoppingCartItem);
        }

        this.debouncedSaveRates(offer.id);

        this.newShoppingCartItem = {
          id: uuid.v4(),
          inHouseServiceId: null,
          itemPrice: 0.0,
          itemCount: 1.0,
          alternativeLabel: null,
          date: null,
        };
      }

      this.showAddTransactionModal = false;
    },
    getAvailableCount(roomOfferId, roomTypeId) {
      const roomOfferRoomTypeAvailability = cloneDeep(this.roomOfferRoomTypeAvailability);
      if (!isNil(roomOfferRoomTypeAvailability)) {
        if (!isNil(roomOfferRoomTypeAvailability[roomOfferId])) {
          if (!isNil(roomOfferRoomTypeAvailability[roomOfferId][roomTypeId])) {
            return roomOfferRoomTypeAvailability[roomOfferId][roomTypeId];
          }
        }
      }
      return null;
    },
    isEmpty,
    getRatePlanPolicyName(ratePlanId) {
      try {
        return `${this.$t('pageRoomReservation.policies.policyOverrideNoSelectOption')} (${this.findHotelSettingById('policies', this.findHotelSettingById('ratePlans', ratePlanId).policyId).name})`;
      } catch (e) {
        return '-';
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageGuestOffer.vue